import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import Message, { MessageMood } from '../Message';
import * as styles from './style.module.css';
const StatusMessageHeader = ({ header, headerIcon }) => {
    if (!header)
        return null;
    const wrapperClasses = clsx(headerIcon && styles.headerWithIcon);
    const messageHeaderClasses = clsx(styles.messageHeader);
    const DepotIcon = headerIcon;
    if (DepotIcon)
        DepotIcon.displayName = 'DepotIcon';
    return Depot.createElement('div', {}, React.createElement("div", { className: wrapperClasses },
        DepotIcon && React.createElement(DepotIcon, { size: 24 }),
        React.createElement(Message.Header, { className: messageHeaderClasses }, header)));
};
export const statusMessageAllowedMoods = [
    MessageMood.INFO,
    MessageMood.POSITIVE,
    MessageMood.WARNING,
    MessageMood.NEGATIVE,
];
const StatusMessageWithoutRef = ({ mood, body, header, headerIcon, action, className, testId, direction = 'horizontal', position = 'inset', ...commonProps }) => {
    const pascalCasedMood = mood[0].toUpperCase() + mood.slice(1);
    const leftBorderMoodClass = `leftBorder${pascalCasedMood}`;
    const messageClasses = clsx(styles.message, styles[leftBorderMoodClass], styles.leftBorder, direction === 'vertical' && styles.vertical, position === 'flush' && styles.flush, className);
    const trailingItemClasses = clsx(styles.trailingItem);
    return Depot.createElement('div', {
        ...commonProps,
        testId,
    }, React.createElement(Message, { "data-testid": `${testId}-Message`, className: messageClasses, mood: mood },
        React.createElement(Message.Content, null,
            React.createElement(StatusMessageHeader, { header: header, headerIcon: headerIcon }),
            React.createElement(Message.Body, null, body)),
        action && (React.createElement(Message.TrailingItem, { testId: "statusMessage-trailingItem", className: trailingItemClasses }, action))));
};
const StatusMessage = Depot.withRef(StatusMessageWithoutRef);
StatusMessage.displayName = 'StatusMessage';
export default StatusMessage;
//# sourceMappingURL=index.js.map